import { useNavigate, generatePath, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

// import { logoutUser } from "../store/slices/UserSlice";
//import { useState } from "react";
import mem from "../../assets/img/memlogo.png";
import pro from "../../assets/img/plogo.png";
import CalendarClock from "../../assets/img/calendar-clock.png";
// import lout from "../../assets/img/signout.png";
import lead from "../../assets/img/leadlogo.png";
// import fra from "../../assets/img/Frame.png";
import insplogo from "../../assets/img/insplogo.png";
import actonlogo from "../../assets/img/actionlogo.png";
import adminlogo from "../../assets/img/admlogo.png";
import qrcodelogo from "../../assets/img/qrlogo.png";
import settings from "../../assets/img/sett.png";

import navbarimg from "../../assets/img/navbarblack.png";
import dashboardlog from "../../assets/img/dashboardlogo.png";
import useGetClientId from "../../hooks/useGetClientId";
// import clientProfile from "../../assets/img/ClientProfile.png";
const SidebarIcons = (props) => {
  const { clientNameParam } = useParams();
  const navigate = useNavigate();
  const { userObj } = useSelector((state) => state.user);
  // const dispatch = useDispatch();
  const clientObj = useGetClientId();

  //const [isOpen, setIsOpen] = useState(false);
  const hideSideBar = () => {
    // eslint-disable-next-line react/prop-types
    props.setHideSidebar(!props.hideSidebar);
  };
  return (
    <div
      className={`sideNavBar showIcons overflow-x-auto mobile-bottom-navbar`}
      style={{
        width: "68px",
        //marginTop: "88px"
        marginTop: "0px",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.25)",
        overflowY: "scroll",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      {/* <div className="mb-5 ">
        <img src={finallogo} className="finalsidelogo" alt="logo" />
        <img
          src={sidebarlogo}
          className="sidelogo"
          alt="logo"
          //onClick={() => setIsOpen(!isOpen)}
          onClick={onToggle}
          style={{ cursor: "pointer" }}
        />
      </div> */}
      {/* <ul className="navbar-nav">
        <li className="nav-item mt-0 my-3">
          <a
            className="nav-link active"
            aria-current="page"
            href="/property-form"
          >
            <i className="fa-solid fa-house"></i>Dashboard
          </a>
        </li>
      </ul> */}
      {/* <p className="fs-6 fw-semibold mt-2 mb-2 text-start">ACCOUNT PAGES</p> */}

      <ul className="navbar-nav" style={{ marginTop: "0px" }}>
        <li className="nav-item my-3" style={{ marginLeft: "5px" }}>
          <button
            className="navbarMenuBtn"
            id="navbarNav"
            onClick={() => {
              hideSideBar();
            }}
          >
            {/* <span className="navbar-toggler-icon"></span> */}
            <img src={navbarimg} className="navbar-toggler-icon" alt="logo" />
          </button>
        </li>
        {/* <li className="nav-item my-3" style={{marginLeft: "10px"}}>
          <button className="nav-link  p-0" aria-current="page" href="#">
            <i className="fa-solid fa-user"></i>Profile
          </button>
        </li> */}
        {/* <li className="nav-item my-3" style={{marginLeft: "10px"}}>
          <button
            className="nav-link p-0"
            aria-current="page"
            onClick={() => {
              navigate(
                  generatePath("/client/:clientNameParam/myBooking", {
                    clientNameParam,
                  })
                );
            }}
          >
            <i className="fa-solid fa-calendar"></i>My Bookings
          </button>
        </li> */}
        {/* {userObj?.isAdmin && (
          <li className="nav-item my-3 mt-4" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0 mt-3"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/QRCodes", {
                    clientNameParam,
                  })
                );
              }}
              title="Generate QR Code"
            >
              <img src={qrcodelogo} className="sidelogo" alt="logo" />
            </button>
          </li>
        )} */}

        {clientObj.roleId == 3 && (
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/approverDashboard", {
                    clientNameParam,
                  }),
                );
              }}
              title="Dashboard"
            >
              <img src={dashboardlog} className="sidelogo" alt="logo" />
            </button>
          </li>
        )}


        {clientObj.roleId == 2 && (
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/property-form", {
                    clientNameParam,
                  }),
                );
              }}
              title="Dashboard"
            >
              <img src={dashboardlog} className="sidelogo" alt="logo" />
            </button>
          </li>
        )}
        {userObj?.isAdmin && (
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/adminDashboard", {
                    clientNameParam,
                  }),
                );
              }}
              title="Admin"
            >
              <img src={adminlogo} className="sidelogo" alt="logo" />
              {/* <span className="menu-text">Admin</span> */}
            </button>
          </li>
        )}

        {userObj?.isAdmin && (
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/members", {
                    clientNameParam,
                  }),
                );
              }}
              title="Users"
            >
              {/* <img src={mem} className="sidelogo" alt="logo" />
              Members */}
              <img src={mem} className="sidelogo" alt="logo" />
              {/* <span className="menu-text">Members</span> */}
            </button>
          </li>
        )}
        {userObj?.isAdmin && (
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/siteDashboard", {
                    clientNameParam,
                  }),
                );
              }}
              title="Site Dashboard"
            >
              <img src={pro} className="sidelogo" alt="logo" />
              {/* <span className="menu-text">Site Dashboard</span> */}
            </button>
          </li>
        )}
        {(userObj?.isAdmin || clientObj.roleId == 2) && (
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/calendar", {
                    clientNameParam,
                  }),
                );
              }}
              title="Calendar"
            >
              <img src={CalendarClock} className="sidelogo" alt="logo" />
            </button>
          </li>
        )}
        {/* {userObj?.isAdmin && (
          <li className="nav-item my-3" style={{marginLeft: "10px"}}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/subscription", {
                    clientNameParam,
                  })
                );
              }}
            >
              <i className="fa-solid fa-credit-card"></i>Subscription
            </button>
          </li>
        )} */}
        {userObj?.isAdmin && (
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/inspectionDashboard", {
                    clientNameParam,
                  }),
                );
              }}
              title="Inspections"
            >
              <img src={insplogo} className="sidelogo" alt="logo" />
              {/* <span className="menu-text">Inspection</span> */}
            </button>
          </li>
        )}

        {userObj?.isAdmin && (
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/leadDashboard", {
                    clientNameParam,
                  }),
                );
              }}
              title="Bookings"
            >
              <img src={lead} className="sidelogo" alt="logo" />
              {/* <span className="menu-text">Lead</span> */}
            </button>
          </li>
        )}
        {(userObj?.isAdmin || clientObj.roleId == 3) && (
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/actionRemediation", {
                    clientNameParam,
                  }),
                );
              }}
              title="Action Plan"
            >
              <img src={actonlogo} className="sidelogo" alt="logo" />
              {/* <span className="menu-text">Lead</span> */}
            </button>
          </li>
        )}

        {/* <li className="nav-item my-3" style={{marginLeft: "10px"}}>
          <button className="nav-link p-0" aria-current="page" href="#">
            <i className="fa-solid fa-sign-in"></i>Sign In
          </button>
        </li>
        <li className="nav-item my-3" style={{marginLeft: "10px"}}>
          <button className="nav-link p-0" aria-current="page" href="#">
            <i className="fa-solid fa-rocket"></i>Sign Up
          </button>
        </li> */}
        {userObj?.isAdmin && (
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/QRCodes", {
                    clientNameParam,
                  }),
                );
              }}
              title="Generate QR Code"
            >
              <img src={qrcodelogo} className="sidelogo" alt="logo" />
            </button>
          </li>
        )}

        {userObj?.isAdmin && (
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/ClientBranding", {
                    clientNameParam,
                  }),
                );
              }}
              title="Settings"
            >
              {/* <img src={mem} className="sidelogo" alt="logo" />
              Members */}
              <img src={settings} className="sidelogo" alt="logo" />
              {/* <span className="menu-text">Members</span> */}
            </button>
          </li>
        )}

        {/* <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
          <button
            className="nav-link p-0 mb-5"
            aria-current="page"
            onClick={() =>
              dispatch(
                logoutUser({
                  userId: userObj?.userId,
                  userIdentifier: userObj?.userEmail,
                })
              )
            }
            title="Sign Out"
          >
            <img src={lout} className="sidelogo" alt="logo" />
         
          </button>
        </li> */}
      </ul>

      {/* <div className="menu_info_card mt-3">
        <div className="col-12 mb-3 ">
          <img src={fra} className="sidelogo" alt="logo" />
        </div>
        <div className="col-12 mb-3">
          <p className="fs-6 fw-semibold mb-4">Need Help?</p>
          <p className="fw-semibold mb-4" style={{ fontSize: "0.7rem" }}>
            Please check our documentation or connect with support.
          </p>
        </div>
        <div className="col-12">
          <button
            type="button"
            className="btn btn-light w-100"
            style={{ backgroundColor: "#E85D04" }}
          >
            Documentation
          </button>
          <button
            type="button"
            className="btn btn-light w-100 mt-2"
            style={{ backgroundColor: "#E85D04", fontSize: "10px" }}
          >
            Connect with Support
          </button>
        </div>
      </div> */}
      {/* <div>
        <ul className="navbar-nav mb-4" style={{ marginTop: "122px" }}>
          <li className="nav-item my-3" style={{ marginLeft: "10px" }}>
            <button
              className="nav-link p-0 mb-5"
              aria-current="page"
              onClick={() =>
                dispatch(
                  logoutUser({
                    userId: userObj?.userId,
                    userIdentifier: userObj?.userEmail,
                  })
                )
              }
              title="Sign Out"
            >
              <img src={lout} className="sidelogo" alt="logo" />
            </button>
          </li>
        </ul>
      </div> */}
    </div>
  );
};

export default SidebarIcons;
